<template>
  <div v-if="isBoolean">
    <RequerimientoBoolean :requerimiento="requerimiento" :can-edit="canEdit" ref="data"></RequerimientoBoolean>
  </div>
  <div v-else-if="isNumerical">
    <RequerimientoNumerical :requerimiento="requerimiento" :can-edit="canEdit" ref="data"></RequerimientoNumerical>
  </div>
  <div v-else-if="isPhone">
    <RequerimientoPhone :requerimiento="requerimiento" :can-edit="canEdit" ref="data"></RequerimientoPhone>
  </div>
  <div v-else-if="isEmail">
    <RequerimientoEmail :requerimiento="requerimiento" :can-edit="canEdit" ref="data"></RequerimientoEmail>
  </div>
  <div v-else>
    <RequerimientoPlainText :requerimiento="requerimiento" :can-edit="canEdit" ref="data"></RequerimientoPlainText>
  </div>
</template>

<script>
import Constants from '../../../../common/constants'
import RequerimientoBoolean from './RequerimientoBoolean'
import RequerimientoNumerical from './RequerimientoNumerical'
import RequerimientoPhone from './RequerimientoPhone'
import RequerimientoEmail from './RequerimientoEmail'
import RequerimientoPlainText from './RequerimientoPlainText'

export default {
  props: {
    requerimiento: Object
  },

  components: {
    RequerimientoBoolean,
    RequerimientoNumerical,
    RequerimientoPhone,
    RequerimientoEmail,
    RequerimientoPlainText
  },

  computed: {
    isBoolean () {
      return this.requerimiento.tipo === Constants.REQUERIMIENTO_HAS_BOOLEAN
    },
    isNumerical () {
      return this.requerimiento.tipo === Constants.REQUERIMIENTO_HAS_NUMBER
    },
    isPhone () {
      return this.requerimiento.tipo === Constants.REQUERIMIENTO_HAS_PHONE
    },
    isEmail () {
      return this.requerimiento.tipo === Constants.REQUERIMIENTO_HAS_EMAIL
    },
    canEdit () {
      return this.requerimiento.allowed === 'user'
    }
  },

  methods: {
    isValid () {
      return this.$refs.data.isValid()
    },
    isModified () {
      return this.$refs.data.isModified()
    },
    getData () {
      return this.$refs.data.getData()
    }
  }
}
</script>
